import React, { Component } from 'react';
import { Button, Form, Grid, Header, Image, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { REGEX_PATTERNS } from '../config/constants';
import { login, resetPassword } from '../helpers/auth';
import { AlertBox, ConfirmBox, setAlertMsg, askConfirmation } from '../components/Modals';

export default class Login extends Component {
  state = {
    loggingIn: false,
  }

  inputFields = {
    email: null,
    password: null,
  }

  handleSubmit = (e) => {
    // console.log(this.inputFields.email, this.inputFields.password)
    e.preventDefault();
    if (!REGEX_PATTERNS.email.test(this.inputFields.email)) {
      return this.setState(setAlertMsg('auth/invalid-email', 'Authentification impossible'));
    } else if (!this.inputFields.password) {
      return this.setState(setAlertMsg('auth/password-required', 'Authentification impossible'));
    }
    this.setState({ loggingIn: true });
    return login(this.inputFields.email, this.inputFields.password).then(() => {
      this.setState({ loggingIn: false });
    })
      .catch((error) => {
        console.log(error);
        this.setState({ loggingIn: false });
        this.setState(setAlertMsg(error.code || null, 'Authentification impossible'));
      });
  }
  resetPassword = (e) => {
    e.preventDefault();
    if (!REGEX_PATTERNS.email.test(this.inputFields.email)) {
      return this.setState(setAlertMsg(
        'auth/invalid-email',
        'Réinitialisation du mot de passe impossible',
      ));
    }
    return this.setState(askConfirmation(
      'Réinitialisation du mot de passe',
      `Un email contenant un lien de réinitialisation de mot de passe va être envoyé à l'adresse <em>${this.inputFields.email}</em>.<br/><br/>` +
      'Voulez-vous continuer ?',
      'neutral',
      () => {
        resetPassword(this.inputFields.email)
          .then(() => this.setState(setAlertMsg(
            null,
            'Réinitialisation du mot de passe',
            `Un email contenant un lien de réinitialisation a été envoyé à l'adresse <em>${this.inputFields.email}.</em>`,
            'success',
          )))
          .catch((error) => {
            console.log(error);
            this.setState(setAlertMsg(
              error.code || null,
              'Impossible d\'envoyer l\'email de réinitialisation',
            ));
          });
      },
    ));
  };

  render() {
    return (
      <div className="login-form">
        <style>
          {`
            body > div#root,
            body > div#root > div,
            body > div#root > div > div,
            body > div#root > div > div ,
            body > div#root > div > div > div.login-form {
              height: 100%;
            }
          `}
        </style>
        <Grid
          textAlign="center"
          style={{ height: '100%' }}
          verticalAlign="middle"
        >
          <Grid.Column style={{ maxWidth: 450 }}>
            <Image size="small" src="/images/web-logo.svg" centered verticalAlign="bottom" />
            <Header as="h2" textAlign="center" inverted>
              Authentification requise
            </Header>
            <Form size="large" onSubmit={this.handleSubmit}>
              <Segment stacked>
                <Form.Input
                  fluid
                  autoFocus
                  icon="user"
                  iconPosition="left"
                  onChange={(e) => {
                    this.inputFields.email = e.target.value.toLowerCase();
                  }}
                  placeholder="Adresse Email"
                  type="email"
                />
                <Form.Input
                  fluid
                  icon="lock"
                  iconPosition="left"
                  placeholder="Mot de passe"
                  onChange={(e) => {
                    this.inputFields.password = e.target.value;
                  }}
                  type="password"
                />
                <Button
                  fluid
                  color="blue"
                  type="submit"
                  loading={this.state.loggingIn}
                >Connexion
                </Button>
              </Segment>
            </Form>
            <Segment basic className="whiteText">
              <Link to="/register" onClick={this.resetPassword} className="whiteText">Mot de passe
                perdu
              </Link>
              &nbsp;|&nbsp;
              <Link to="/register" className="whiteText">Création de compte</Link>
            </Segment>
          </Grid.Column>
        </Grid>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Login.js